import { computed } from 'vue'
import { useStore } from 'vuex'

export default computed(() => {
  const store = useStore()

  return [
    {
      to: '/dashboard',
      icon: 'fas fa-home',
      label: 'Dashboard',
      routeName: 'Dashboard',
    },
    {
      to: '/clients',
      icon: 'fas fa-users',
      label: 'Clients',
      routeName: 'Clients',
    },
    {
      to: '/products',
      icon: 'fas fa-cubes',
      label: 'Produits',
      routeName: 'Products',
    },
    {
      to: '/quotes',
      icon: 'fas fa-inbox',
      label: 'Devis',
      routeName: 'Quotes',
    },
    {
      to: '/invoices',
      icon: 'fas fa-file-import',
      label: 'Factures',
      routeName: 'Invoices',
      counters: [
        { count: store.state.COUNTERS?.INVOICES?.NO_PAYMENTS || 0, class: 'bg-red-500' },
        { count: store.state.COUNTERS?.INVOICES?.REMAINING || 0, class: 'bg-orange-500' },
      ],
    },
    {
      to: '/credit-notes',
      icon: 'fas fa-file-export',
      label: 'Notes de crédit',
      routeName: 'Credit Notes',
    },
    {
      to: '/production',
      icon: 'fas fa-box-open',
      label: 'Production',
      routeName: 'Production',
      className: 'mt-2',
      counters: [
        { count: store.state.COUNTERS?.PRODUCTION?.BACKLOG || 0, class: 'bg-orange-500' },
        { count: store.state.COUNTERS?.PRODUCTION?.DECOUPAGE || 0, class: 'bg-yellow-500' },
        { count: store.state.COUNTERS?.PRODUCTION?.POLISSAGE || 0, class: 'bg-indigo-400' },
      ],
    },
  ]
})
